import { render, staticRenderFns } from "./InSwitchLEDAlice.vue?vue&type=template&id=0a6747a2&scoped=true&"
import script from "./InSwitchLEDAlice.vue?vue&type=script&lang=js&"
export * from "./InSwitchLEDAlice.vue?vue&type=script&lang=js&"
import style0 from "./InSwitchLEDAlice.vue?vue&type=style&index=0&id=0a6747a2&lang=scss&scoped=true&"
import style1 from "./InSwitchLEDAlice.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6747a2",
  null
  
)

export default component.exports